export enum Modals {
  ACTION_CREATE_MODAL = 'ACTION_CREATE_MODAL',
  ACTION_FULL_MODAL = 'ACTION_FULL_MODAL',
  ACTION_MINIMIZED_MODAL = 'ACTION_MINIMIZED_MODAL',
  ADD_LINK_FOR_ACTIVITY_MODAL = 'ADD_LINK_FOR_ACTIVITY_MODAL',
  AI_CHAT_MODAL = 'AI_CHAT_MODAL',
  AI_FIELD_VALUE_MODAL = 'AI_FIELD_VALUE_MODAL',
  AI_LINKED_FORMS_MODAL = 'AI_LINKED_FORMS_MODAL',
  AI_MATRIX_VALUE_MODAL = 'AI_MATRIX_VALUE_MODAL',
  API_CLIENT_CREATE_MODAL = 'API_CLIENT_CREATE_MODAL',
  API_CLIENT_SECRET_MODAL = 'API_CLIENT_SECRET_MODAL',
  API_CLIENT_UPDATE_MODAL = 'API_CLIENT_UPDATE_MODAL',
  AUTH_COMPANY_SELECT_MODAL = 'AUTH_COMPANY_SELECT_MODAL',
  BUSINESS_ENTITY_MODAL = 'BUSINESS_ENTITY_MODAL',
  CHANGE_USER_PASSWORD_MODAL = 'CHANGE_USER_PASSWORD_MODAL',
  CONFIRM_CHANGE_PARENT_PLAN_MODAL = 'CONFIRM_CHANGE_PARENT_PLAN_MODAL',
  CONFIRM_CHANGE_PLAN_TYPE_MODAL = 'CONFIRM_CHANGE_PLAN_TYPE_MODAL',
  CONFIRM_DELETE_ACTION_MODAL = 'CONFIRM_DELETE_ACTION_MODAL',
  CONFIRM_DELETE_ACTIVITY_MODAL = 'CONFIRM_DELETE_ACTIVITY_MODAL',
  CONFIRM_DELETE_CHAT_CONVERSATION_MODAL = 'CONFIRM_DELETE_CHAT_CONVERSATION_MODAL',
  CONFIRM_DELETE_DASHBOARD_MODAL = 'CONFIRM_DELETE_DASHBOARD_MODAL',
  CONFIRM_DELETE_KPI_MODAL = 'CONFIRM_DELETE_KPI_MODAL',
  CONFIRM_DELETE_KPI_RESULT_MODAL = 'CONFIRM_DELETE_KPI_RESULT_MODAL',
  CONFIRM_DELETE_MATRIX_ITEM_MODAL = 'CONFIRM_DELETE_MATRIX_ITEM_MODAL',
  CONFIRM_DELETE_MODAL = 'CONFIRM_DELETE_MODAL',
  CONFIRM_DELETE_OBJECTIVE_MODAL = 'CONFIRM_DELETE_OBJECTIVE_MODAL',
  CONFIRM_DELETE_PLAN_ITEM = 'CONFIRM_DELETE_PLAN_ITEM',
  CONFIRM_DELETE_REVIEW_MODAL = 'CONFIRM_DELETE_REVIEW_MODAL',
  CONFIRM_DELETE_RISK_MODAL = 'CONFIRM_DELETE_RISK_MODAL',
  CONFIRM_DELETE_RISK_TEMPLATE_MODAL = 'CONFIRM_DELETE_RISK_TEMPLATE_MODAL',
  CONFIRM_DELETE_RISK_VIEW_MODAL = 'CONFIRM_DELETE_RISK_VIEW_MODAL',
  CONFIRM_DELETE_SCHEDULED_REVIEW = 'CONFIRM_DELETE_SCHEDULED_REVIEW',
  CONFIRM_DELETE_WIDGET_MODAL = 'CONFIRM_DELETE_WIDGET_MODAL',
  CONFIRM_EDIT_REVIEW_MODAL = 'CONFIRM_EDIT_REVIEW_MODAL',
  CONFIRM_UNLINK_PLAN_ITEM_MODAL = 'CONFIRM_UNLINK_PLAN_ITEM_MODAL',
  DASHBOARD_SETTINGS_MODAL = 'DASHBOARD_SETTINGS_MODAL',
  DASHBOARD_WIDGET_SETTINGS_MODAL = 'DASHBOARD_WIDGET_SETTINGS_MODAL',
  EDIT_ACTIVITY_MODAL = 'EDIT_ACTIVITY_MODAL',
  EMAIL_PREVIEW_MODAL = 'EMAIL_PREVIEW_MODAL',
  GROUP_SECURITY_MODAL = 'GROUP_SECURITY_MODAL',
  IMAGE_CROPPER_MODAL = 'IMAGE_CROPPER_MODAL',
  IMPORTED_RISK_MODAL = 'IMPORTED_RISK_MODAL',
  INJURY_MASTER_REVOKE_MODAL = 'INJURY_MASTER_REVOKE_MODAL',
  INJURY_MASTER_SETTINGS_MODAL = 'INJURY_MASTER_SETTINGS_MODAL',
  KPI_CREATE_MODAL = 'KPI_CREATE_MODAL',
  KPI_FULL_MODAL = 'KPI_FULL_MODAL',
  KPI_INTEGRATION_MODAL = 'KPI_INTEGRATION_MODAL',
  KPI_MINIMIZED_MODAL = 'KPI_MINIMIZED_MODAL',
  KPI_RECURRENCE_MODAL = 'KPI_RECURRENCE_MODAL',
  KPI_RESULTS_MODAL = 'KPI_RESULTS_MODAL',
  KPI_SCALE_MODAL = 'KPI_SCALE_MODAL',
  KPI_SET_RESULT_ROW_MODAL = 'KPI_SET_RESULT_ROW_MODAL',
  LINKED_FORM_VIEW_MODAL = 'LINKED_FORM_VIEW_MODAL',
  LINKING_SOURCE_DETAILS_MODAL = 'LINKING_SOURCE_DETAILS_MODAL',
  LOOKUP_FILTER_MODAL = 'LOOKUP_FILTER_MODAL',
  NEW_USER_MODAL = 'NEW_USER_MODAL',
  OBJECTIVE_FULL_MODAL = 'OBJECTIVE_FULL_MODAL',
  OBJECTIVE_MINIMIZED_MODAL = 'OBJECTIVE_MINIMIZED_MODAL',
  OBJECT_SECURITY_MODAL = 'OBJECT_SECURITY_MODAL',
  PICKLIST_OPTION_MODAL = 'PICKLIST_OPTION_MODAL',
  PLAN_ACTIVITIES_MODAL = 'PLAN_ACTIVITIES_MODAL',
  PLAN_CLONE_MODAL = 'PLAN_CLONE_MODAL',
  PLAN_FILTER_MODAL = 'PLAN_FILTER_MODAL',
  PLAN_ITEM_PREVIEW_MODAL = 'PLAN_ITEM_PREVIEW_MODAL',
  PLAN_CREATE_MODAL = 'PLAN_CREATE_MODAL',
  PLAN_OBJECTIVES_LIST_MODAL = 'PLAN_OBJECTIVES_LIST_MODAL',
  PLAN_SCHEDULE_DEFAULTS_MODAL = 'PLAN_SCHEDULE_DEFAULTS_MODAL',
  PLAN_COLUMNS_SETTINGS_MODAL = 'PLAN_COLUMNS_SETTINGS_MODAL',
  PLAN_TYPE_CREATE_MODAL = 'PLAN_TYPE_CREATE_MODAL',
  PROPERTY_DETAILS_MODAL = 'PROPERTY_DETAILS_MODAL',
  REPORT_PERMISSIONS_MODAL = 'REPORT_PERMISSIONS_MODAL',
  REPORT_UPDATE_MODAL = 'REPORT_UPDATE_MODAL',
  RESOURCE_CREATE_MODAL = 'RESOURCE_CREATE_MODAL',
  RESPONSE_TYPES_SET_MODAL = 'RESPONSE_TYPES_SET_MODAL',
  REVIEW_CREATE_MODAL = 'REVIEW_CREATE_MODAL',
  REVIEW_DETAILS_MODAL = 'REVIEW_DETAILS_MODAL',
  RISK_CONFIRM_MODAL = 'RISK_CONFIRM_MODAL',
  RISK_EDIT_PREFIX_MODAL = 'RISK_EDIT_PREFIX_MODAL',
  RISK_FIELD_HISTORY_MODAL = 'RISK_FIELD_HISTORY_MODAL',
  RISK_FIELD_RECURRENCE_MODAL = 'RISK_FIELD_RECURRENCE_MODAL',
  RISK_MANDATORY_CHECK_MODAL = 'RISK_MANDATORY_CHECK_MODAL',
  RISK_MATRIX_APPETITE_CONF_MODAL = 'RISK_MATRIX_APPETITE_CONF_MODAL',
  RISK_MATRIX_APPETITE_OPTIONS_MODAL = 'RISK_MATRIX_APPETITE_OPTIONS_MODAL',
  RISK_MATRIX_MODAL = 'RISK_MATRIX_MODAL',
  RISK_MATRIX_OPTIONS_MODAL = 'RISK_MATRIX_OPTIONS_MODAL',
  RISK_RECURRENCE_MODAL = 'RISK_RECURRENCE_MODAL',
  RISK_TEMPLATE_ADD_FORM_MODAL = 'RISK_TEMPLATE_ADD_FORM_MODAL',
  RISK_TEMPLATE_SETTINGS_MODAL = 'RISK_TEMPLATE_SETTINGS_MODAL',
  RISK_TEMPLATE_SYSTEM_PROCESSES_MODAL = 'RISK_TEMPLATE_SYSTEM_PROCESSES_MODAL',
  RISK_VIEW_ADD_FILTER_MODAL = 'RISK_VIEW_ADD_FILTER_MODAL',
  RISK_VIEW_CREATE_MODAL = 'RISK_VIEW_CREATE_MODAL',
  RISK_VIEW_FILTER_MODAL = 'RISK_VIEW_FILTER_MODAL',
  SCALE_OPTION_CREATE_MODAL = 'SCALE_OPTION_CREATE_MODAL',
  SCALE_OPTION_EDIT_MODAL = 'SCALE_OPTION_EDIT_MODAL',
  SCHEDULED_RISK_RECURRENCE_MODAL = 'SCHEDULED_RISK_RECURRENCE_MODAL',
  SCHEDULE_REVIEW_MODAL = 'SCHEDULE_REVIEW_MODAL',
  SECURITY_PROFILE_MODAL = 'SECURITY_PROFILE_MODAL',
  SESSION_EXPIRING_MODAL = 'SESSION_EXPIRING_MODAL',
  SELECT_MULTI_VALUE_MODAL = 'SELECT_MULTI_VALUE_MODAL',
  SET_COLOR_MODAL = 'SET_COLOR_MODAL',
  SET_DAY_WORKING_HOURS_MODAL = 'SET_DAY_WORKING_HOURS_MODAL',
  SET_DOCUMENT_DESCRIPTION_MODAL = 'SET_DOCUMENT_DESCRIPTION_MODAL',
  SET_LICENCING_MODAL = 'SET_LICENCING_MODAL',
  SIDEBAR_REVIEW_DETAILS_MODAL = 'SIDEBAR_REVIEW_DETAILS_MODAL',
  SUB_PLAN_CREATE_MODAL = 'SUB_PLAN_CREATE_MODAL',
  SYNC_RULES_MODAL = 'SYNC_RULES_MODAL',
  SYSTEM_PROCESS_CREATE_MODAL = 'SYSTEM_PROCESS_CREATE_MODAL',
  TEXT_FIELD_CONTENT = 'TEXT_FIELD_CONTENT',
  TWO_FACTOR_ADMIN_RESET_MODAL = 'TWO_FACTOR_ADMIN_RESET_MODAL',
  TWO_FACTOR_DISABLE_MODAL = 'TWO_FACTOR_DISABLE_MODAL',
  TWO_FACTOR_REGENERATE_CODES_MODAL = 'TWO_FACTOR_REGENERATE_CODES_MODAL',
  TWO_FACTOR_SETUP_MODAL = 'TWO_FACTOR_SETUP_MODAL'
}
